import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';
import type {SelfEmploymentProvider} from './fetchEmployment';

type UpdateEmploymentOperation = paths['/executor_web/employment']['put'];

export type UpdateEmploymentRequest = NonNullable<
	NonNullable<UpdateEmploymentOperation['requestBody']>['content']['application/json']
> & {
	/** Только СМЗ: бэк выбирает профиль в selfEmploymentProfiles. */
	provider?: SelfEmploymentProvider;
};
export type UpdateEmploymentResponse = UpdateEmploymentOperation['responses'][200]['content']['application/json'];
export type UpdateEmploymentErrorResponse = UpdateEmploymentOperation['responses'][400]['content']['application/json'];

/** PUT `/executor_web/employment` — см. `paths['/executor_web/employment']` в auth swagger */
export function updateEmployment(request: UpdateEmploymentRequest, signal?: AbortSignal) {
	return axiosInstance.put<UpdateEmploymentResponse>('employment', request, {signal});
}
